import {CreateOpportunityParams} from '../../models/opportunity';

export interface OpportunityCreateServiceParams extends CreateOpportunityParams {
  accountId: string;
  organizationId: string;
}

export enum LocationType {
  HYBRID = 'HYBRID',
  ONSITE = 'ONSITE',
  REMOTE = 'REMOTE',
}

export enum JobType {
  CONTRACT = 'CONTRACT',
  FREELANCE = 'FREELANCE',
  FULL_TIME = 'FULL_TIME',
  INTERNSHIP = 'INTERNSHIP',
  PART_TIME = 'PART_TIME',
}

export enum OpportunitySortBy {
  NEWEST = 'newest',
  OLDEST = 'oldest',
}

export class OpportunitySearchParams {
  applied?: boolean;
  search?: string;
  department?: string;
  employmentType?: string;
  experienceLevel?: string;
  educationRequirements?: string;
  status?: string;
  locationType?: string;
  jobType?: string;
  postedWithin?: string;
  organizationIds?: string[];
  page: number;
  limit: number;
  sortBy: OpportunitySortBy;

  constructor(params: {
    applied?: boolean;
    search?: string;
    department?: string;
    employmentType?: string;
    experienceLevel?: string;
    educationRequirements?: string;
    status?: string;
    locationType?: string;
    jobType?: string;
    postedWithin?: string;
    organizationIds?: string[];
    page: number;
    limit: number;
    sortBy: OpportunitySortBy;
  }) {
    this.applied = params.applied;
    this.search = params.search;
    this.department = params.department;
    this.employmentType = params.employmentType;
    this.experienceLevel = params.experienceLevel;
    this.educationRequirements = params.educationRequirements;
    this.status = params.status;
    this.locationType = params.locationType;
    this.jobType = params.jobType;
    this.postedWithin = params.postedWithin;
    this.organizationIds = params.organizationIds;
    this.page = params.page;
    this.limit = params.limit;
    this.sortBy = params.sortBy;
  }
}
